import { createContext } from "react";

type TabContextType = {
  size: "sm" | "md";
  variant: "primary" | "secondary";
  vertical?: boolean;
};

const TabContext = createContext<TabContextType>({
  size: "md",
  variant: "primary",
  vertical: false,
});

export default TabContext;
